import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-gallery',
  templateUrl: './video-gallery.component.html',
  styleUrls: ['./video-gallery.component.scss']
})
export class VideoGalleryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.video();
  }

  video(){
    var v = document.getElementsByClassName("youtube-player");
    for (var n = 0; n < v.length; n++) {
        v[n].addEventListener("click",function() {
          var iframe = document.createElement("iframe");
          iframe.setAttribute("src", "//www.youtube.com/embed/" + this.dataset.id + "?autohide=2&border=0&wmode=opaque&enablejsapi=1&rel=" + this.dataset.related + "&controls=" + this.dataset.control + "&showinfo=" + this.dataset.info);
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("id", "youtube-iframe");
          iframe.setAttribute("style", "width: 100%; height: 100%; position: absolute; top: 0; left: 0;");
          if (this.dataset.fullscreen == 1) {
              iframe.setAttribute("allowfullscreen", "");
          }
          while (this.firstChild) {
              this.removeChild(this.firstChild);
          }
          this.appendChild(iframe);
      }) 
    }
  }
}
